export class UpdateResourcePageRequest {
    pageId: number;
    pageName: string;
    pageContent: string;
    category: number;
    mainImageId: string;
    attachmentsToAdd: string[];
    attachmentsToRemove: string[];
}